// extracted by mini-css-extract-plugin
export var hidden = "_v8-0";